// /app's first screen that the server puts in the HTML on phones (lib/initial-app.js, TEAMBRIDGE_APP_FIRST_SCREEN).
// The game picker takes it over when it mounts: the game tapped meanwhile and how far it was scrolled.
const OVERLAY_ID = 'tb-initial-app';
export function takeInitialApp(win = typeof window === 'undefined' ? null : window) {
  const overlay = win?.document?.getElementById(OVERLAY_ID);
  if (!overlay) return null;
  const state = {
    pick: win.__tbInitialApp?.pick || null,
    scrollTop: overlay.scrollTop || 0
  };
  overlay.remove();
  return state;
}
export const dropInitialApp = takeInitialApp;